import { ActionFunctionArgs, LoaderFunctionArgs } from "react-router-dom";

/**
 * Helper to define route loader functions. Automatically handles
 * Response objects. Redirects can be `thrown` instead of returned.
 *
 * @example
 * import { defineLoader } from "toolbox/Router";
 *
 * export const loader = defineLoader(async ({ params }) => {
 *  if (!params.platformId) throw redirect("/admin/clients");
 *  return { hello: "world" };
 * });
 */
export const defineLoader = <T>(loader: (args: LoaderFunctionArgs) => T) => {
  return (args: LoaderFunctionArgs) => {
    return loader(args);
  };
};

/**
 * Helper to define route action functions. Automatically handles
 * Response objects. Redirects can be `thrown` instead of returned.
 *
 * @example
 * import { defineAction } from "toolbox/Router";
 *
 * export const action = defineAction(async ({ request }) => {
 *  const formData = await request.formData();
 *  if (!formData.get("platformId")) return { error: "Platform ID is required" };
 *
 *  throw redirect("/admin/clients");
 * });
 */
export const defineAction = <T>(action: (args: ActionFunctionArgs) => T) => {
  return async (args: ActionFunctionArgs) => {
    const data = await action(args);
    return data as Awaited<T>;
  };
};
